var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import BaseSelectController from './base-select-controller';
var SelectController = /** @class */ (function (_super) {
    __extends(SelectController, _super);
    function SelectController() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SelectController.prototype.getDefaultHighlightedOption = function () {
        if (this.shouldDisplayFilter()) {
            return null;
        }
        return this.getSelectedOption() || this.getEnabledOptions(false)[0];
    };
    SelectController.prototype.getSelectedOption = function () {
        var _this = this;
        if (this.component.selectedOption) {
            return this.component.selectedOption;
        }
        if (this.component.selectedId) {
            return this.getEnabledOptions(false).filter(function (option) { return option.id === _this.component.selectedId; })[0];
        }
        return null;
    };
    SelectController.prototype.setSelectedOption = function (option) {
        if (this.component.selectedOption !== undefined) {
            this.component.selectedOption = option;
        }
        else {
            this.component.selectedId = option.id;
        }
    };
    SelectController.prototype.selectOption = function (option) {
        this.setSelectedOption(option);
        this.closeDropdown();
        this.component.__fireEvent('change', { selectedId: option.id, selectedOption: option });
    };
    return SelectController;
}(BaseSelectController));
export default SelectController;
//# sourceMappingURL=select-controller.js.map